import React from 'react';
import styles from './explore.module.css';
import UserCard from './userCard';

const Suggestion =()=>{
    return(
        <div className={styles.CardList}>
        <UserCard
         buttons={
            <div>
        <button className="followbtn">Accept</button>
       
         </div>}
        
        />
        <UserCard/>
        <UserCard/>
        <UserCard/>
        <UserCard/>
        <UserCard/>
        <UserCard/>
        <UserCard/>
        <UserCard/>
        <UserCard/>
        <UserCard/>
        <UserCard/>

    </div>
    )
}

export default Suggestion;